import React from 'react';
import FloatingActionButton from 'material-ui/FloatingActionButton';
import Stop from 'material-ui/svg-icons/av/stop';
import Mic from 'material-ui/svg-icons/av/mic';

const iconStyles = {
  color: '#fff',
};

const Record = (props) => {
  if (!props.deviceConfig.supportsRecording && props.config.environment !== 'android') {
    return <span />;
  }

  const isActive = props.isStopped() || props.isRecording;

  let disabled = !isActive;


  disabled = disabled || (!props.deviceConfig.allowsRecording && props.config.environment !== 'android');


  const label = props.isRecording
            ? <Stop />
            : <Mic />;
  return (
    <span>
      <FloatingActionButton
        id="record"
        title="Record your take"
        backgroundColor="#d52b1e"
        iconStyle={iconStyles}
        onClick={props.record}
        className="pronounce-button record"
        disabled={disabled}
      >
        {label}
      </FloatingActionButton>
      <br />
      Try it yourself
    </span>
        );
}

export default Record;



// WEBPACK FOOTER //
// ./src/components/Record.js